import axios from "axios"

import { devMode } from "./base"
import { arrayToString, arrayObjToString, stypes } from "../components/common/common"

const baseDomain = `https://m-car${devMode ? "-dev" : ""}.mioto.vn`
const baseUploadDomain = `https://f1-up${devMode ? "-dev" : ""}.mioto.vn`
const baseGPSDomain = `https://m-gps${devMode ? "-dev" : ""}.mioto.vn`

export function init() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/init/app`
    })
}

export function searchCarForList(filter) {
    const instantBooking = filter.instantBooking ? "&instant=true" : "";
    const directDelivery = (filter.stype === stypes.SD && filter.directDelivery) ? "&delivery=true" : "";
    const minPrice = filter.minPrice > 0 ? `&minPrice=${filter.minPrice * 1000}` : "";
    const maxPrice = (filter.maxPrice > 0) ? `&maxPrice=${filter.maxPrice * 1000}` : "";
    var features = "";
    if (filter.features && filter.features.length > 0) {
        features = `&features=${arrayToString(filter.features)}`;
    }
		let vType = "";
		if (filter.vehicleType && filter.vehicleType.length > 0) {
			vType = `&vType=${arrayToString(filter.vehicleType)}`;
		} 
		const vMake = (filter.vehicleMake && filter.vehicleMake !== "" && filter.vehicleMake > 0) ? `&vMake=${filter.vehicleMake}` : "";
		let vModel = "";
		if (filter.vehicleModel && filter.vehicleModel.length > 0) {
			vModel = `&vModel=${filter.vehicleModel.join(";")}`;
		} 
    // const vModel = (filter.vehicleModel && filter.vehicleModel !== "" && filter.vehicleModel > 0) ? `&vModel=${filter.vehicleModel}` : "";
    const transmission = filter.transmission > 0 ? `&transmission=${filter.transmission}` : "";

    const limitKM = filter.limitKM >= 0 ? `&limitKM=${filter.limitKM}` : "";
    const maxDPrice = (filter.stype === stypes.SD && filter.dPrice >= 0)? `&maxDPrice=${filter.dPrice * 1000}` : "";
    const maxLimitKMPrice = filter.limitKMPrice >= 0 ? `&maxLimitKMPrice=${filter.limitKMPrice * 1000}` : "";
    // const pVerified = filter.pVerified ? `&pVerified=${filter.pVerified}` : "";
    const fuel = filter.fuel > 0 ? `&fuel=${filter.fuel}` : "";
    const fuelC = filter.fuelC > 0 ? `&fuelC=${filter.fuelC}` : "";
    const seatFrom = filter.minSeat > 0 ? `&seatFrom=${filter.minSeat}` : "";
    const seatTo = filter.maxSeat > 0 ? `&seatTo=${filter.maxSeat}` : "";
    const yearFrom = filter.minYear > 0 ? `&yearFrom=${filter.minYear}` : "";
    const yearTo = filter.maxYear > 0 ? `&yearTo=${filter.maxYear}` : "";
    const radius = filter.radius > 0 ? `&radius=${filter.radius}` : "";
    const fromCarId = (filter.fromCarId && filter.fromCarId !== "") ? `&fromCarId=${filter.fromCarId}` : "";
    const address = (filter.address && filter.address !== "") ? `&address=${Buffer.from(filter.address).toString('base64')}` : "";

    const supportIns = filter.supportIns ? `&supportIns=true` : "";
    const ownerHostFiveStar = filter.ownerHostFiveStar ? `&ownerHostFiveStar=true` : "";
    const vaccinated = filter.vaccinated ? `&vaccinated=true` : "";

    const discount = filter.discount ? `&discount=true` : "" ;

    const deliveryId = filter.deliveryId ? `&deliveryId=${filter.deliveryId}` : "";
    const nonMortgage = filter.nonMortgage ? `&nonMortgage=${filter.nonMortgage}` : "";

    // wd
    const wdLocations = (filter.wdLocations && filter.wdLocations !== "") ? `&wdLocations=${encodeURIComponent(filter.wdLocations)}` : "";
    const wdDistance = filter.wdDistance >= 0 ? `&wdDistance=${filter.wdDistance}` : "";
    const stype = filter.stype ? `&stype=${filter.stype}` : "";
    const wdOneWay = filter.wdDistance > 0 && filter.wdOneWay !== undefined ? `&wdOneWay=${filter.wdOneWay}` : "";
    const wdDistanceBackOW = filter.wdDistance > 0 && filter.wdOneWay ? `&wdDistanceBackOW=${filter.wdDistanceBackOW}` : "";


    return axios({
        withCredentials: true,
        method: "POST",
        url: `${baseDomain}/car/search/list?lat=${filter.lat}&lon=${filter.lng}&st=${filter.startDate.valueOf()}&et=${filter.endDate.valueOf()}&sort=${filter.sort}${minPrice}${maxPrice}${vType}${vMake}${vModel}${transmission}${features}${instantBooking}${directDelivery}${limitKM}${maxDPrice}${maxLimitKMPrice}${fuel}${fuelC}${seatFrom}${seatTo}${yearFrom}${yearTo}${radius}${fromCarId}&pos=${filter.pos}${supportIns}${ownerHostFiveStar}${wdLocations}${wdDistance}${wdDistanceBackOW}${wdOneWay}${stype}${address}${vaccinated}${deliveryId}${discount}${nonMortgage}`
    })
}

export function searchCarForMapV2(filter) {
    const instantBooking = filter.instantBooking ? "&instant=true" : "";
    const directDelivery = (filter.directDelivery || filter.dPrice >= 0) ? "&delivery=true" : "";
    const minPrice = filter.minPrice > 0 ? `&minPrice=${filter.minPrice * 1000}` : "";
    const maxPrice = filter.maxPrice > 0 ? `&maxPrice=${filter.maxPrice * 1000}` : "";
    var features = "";
    if (filter.features && filter.features.length > 0) {
        features = `&features=${arrayToString(filter.features)}`;
		}
		let vType = "";
		if (filter.vehicleType && filter.vehicleType.length > 0) {
			vType = `&vType=${arrayToString(filter.vehicleType)}`;
		} 
    // const vType = filter.vehicleType > 0 ? `&vType=${filter.vehicleType}` : "";
		const vMake = (filter.vehicleMake && filter.vehicleMake !== "" && filter.vehicleMake > 0) ? `&vMake=${filter.vehicleMake}` : "";
		let vModel = "";
		if (filter.vehicleModel && filter.vehicleModel.length > 0) {
			vModel = `&vModel=${filter.vehicleModel.join(";")}`;
		} 
    // const vModel = (filter.vehicleModel && filter.vehicleModel !== "" && filter.vehicleModel > 0) ? `&vModel=${filter.vehicleModel}` : "";
    const transmission = filter.transmission > 0 ? `&transmission=${filter.transmission}` : "";
    const limitKM = filter.limitKM >= 0 ? `&limitKM=${filter.limitKM}` : "";
    const maxDPrice = filter.dPrice >= 0 ? `&maxDPrice=${filter.dPrice * 1000}` : "";
    const maxLimitKMPrice = filter.limitKMPrice >= 0 ? `&maxLimitKMPrice=${filter.limitKMPrice * 1000}` : "";
    const pVerified = filter.pVerified ? `&pVerified=${filter.pVerified}` : "";
    const fuel = filter.fuel > 0 ? `&fuel=${filter.fuel}` : "";
    const fuelC = filter.fuelC > 0 ? `&fuelC=${filter.fuelC}` : "";
    const seatFrom = filter.minSeat > 0 ? `&seatFrom=${filter.minSeat}` : "";
    const seatTo = filter.maxSeat > 0 ? `&seatTo=${filter.maxSeat}` : "";
    const yearFrom = filter.minYear > 0 ? `&yearFrom=${filter.minYear}` : "";
    const yearTo = filter.maxYear > 0 ? `&yearTo=${filter.maxYear}` : "";
    const radius = `&radius=${filter.minMiles}`;
    const radiusBuffer = `&radiusB=${filter.minMiles * 3}`;
    const screenWidth = `&w=${filter.minMiles * 2}`;
    const screenHeight = `&h=${filter.minMiles * 2}`;
    const groupWidth = `&uw=${filter.minMiles / 4}`;
    const groupHeight = `&uh=${filter.minMiles / 4}`;
	const ownerHostFiveStar = filter.ownerHostFiveStar ? `&ownerHostFiveStar=true` : "";
    const nonMortgage = filter.nonMortgage ? `&nonMortgage=${filter.nonMortgage}` : "";
	
    // wd
    const wdLocations = (filter.wdLocations && filter.wdLocations !== "") ? `&wdLocations=${encodeURIComponent(filter.wdLocations)}` : "";
    const wdDistance = filter.wdDistance >= 0 ? `&wdDistance=${filter.wdDistance}` : "";
    const stype = filter.stype ? `&stype=${filter.stype}` : "";
    const wdOneWay = filter.wdDistance > 0 && filter.wdOneWay !== undefined ? `&wdOneWay=${filter.wdOneWay}` : "";
    const wdDistanceBackOW = filter.wdDistance > 0 && filter.wdOneWay ? `&wdDistanceBackOW=${filter.wdDistanceBackOW}` : "";


    return axios({
        withCredentials: true,
        method: "POST",
        url: `${baseDomain}/v2/car/search/map?lat=${filter.lat}&lon=${filter.lng}${vType}${vMake}${vModel}&st=${filter.startDate.valueOf()}&et=${filter.endDate.valueOf()}&sort=${filter.sort}${minPrice}${maxPrice}${transmission}${features}${instantBooking}${directDelivery}${nonMortgage}${limitKM}${maxDPrice}${maxLimitKMPrice}${fuel}${fuelC}${pVerified}${seatFrom}${seatTo}${yearFrom}${yearTo}${radius}${radiusBuffer}${screenWidth}${screenHeight}${groupWidth}${groupHeight}${ownerHostFiveStar}${wdLocations}${wdDistance}${wdDistanceBackOW}${wdOneWay}${stype}`,
    })
}

// export function searchCarForMap(filter) {
//     const instantBooking = filter.instantBooking ? "&instant=true" : "";
//     const directDelivery = filter.directDelivery ? "&delivery=true" : "";
//     const maxPrice = filter.maxPrice > 0 ? `&maxPrice=${filter.maxPrice * 1000}` : "";
//     var features = "";
//     if (filter.features && filter.features.length > 0) {
//         features = `&features=${arrayToString(filter.features)}`;
//     }
//     const vType = filter.vehicleType > 0 ? `&vType=${filter.vehicleType}` : "";
//     const vMake = (filter.vehicleMake && filter.vehicleMake !== "" && filter.vehicleMake > 0) ? `&vMake=${filter.vehicleMake}` : "";
//     const vModel = (filter.vehicleModel && filter.vehicleModel !== "" && filter.vehicleModel > 0) ? `&vModel=${filter.vehicleModel}` : "";
//     const transmission = filter.transmission > 0 ? `&transmission=${filter.transmission}` : "";
//     const limitKM = filter.limitKM >= 0 ? `&limitKM=${filter.limitKM}` : "";
//     const maxDPrice = filter.maxDPrice >= 0 ? `&maxDPrice=${filter.maxDPrice * 1000}` : "";
//     const maxLimitKMPrice = filter.limitKMPrice >= 0 ? `&maxLimitKMPrice=${filter.limitKMPrice * 1000}` : "";
//     const pVerified = filter.pVerified ? `&pVerified=${filter.pVerified}` : "";
//     const fuel = filter.fuel > 0 ? `&fuel=${filter.fuel}` : "";
//     const fuelC = filter.fuelC > 0 ? `&fuelC=${filter.fuelC}` : "";
//     const seatFrom = filter.minSeat > 0 ? `&seatFrom=${filter.minSeat}` : "";
//     const seatTo = filter.maxSeat > 0 ? `&seatTo=${filter.maxSeat}` : "";
//     const yearFrom = filter.minYear > 0 ? `&yearFrom=${filter.minYear}` : "";
//     const yearTo = filter.maxYear > 0 ? `&yearTo=${filter.maxYear}` : "";
//     const radius = `&radius=${filter.minMiles * 3 /*buffered*/}`;

//     return axios({
//         withCredentials: true,
//         method: "POST",
//         url: `${baseDomain}/car/search/map?lat=${filter.lat}&lon=${filter.lng}${vType}${vMake}${vModel}&st=${filter.startDate.valueOf()}&et=${filter.endDate.valueOf()}&sort=${filter.sort}${maxPrice}${transmission}${features}${instantBooking}${directDelivery}${limitKM}${maxDPrice}${maxLimitKMPrice}${fuel}${fuelC}${pVerified}${seatFrom}${seatTo}${yearFrom}${yearTo}${radius}`,
//     })
// }


export function getCarDetail(carId, ex, deliveryId, stype) {
    const carLat = ex && ex.lat > 0 ? `&lat=${ex.lat}` : "";
    const carLng = ex && ex.lng > 0 ? `&lon=${ex.lng}` : "";
    const st = ex && ex.st ? `&st=${ex.st}` : "";
    const et = ex && ex.et ? `&et=${ex.et}` : "";
    const pVw = ex && ex.vw ? `&vw=${ex.vw}` : "";
    const pDeliveryId = deliveryId ? `&deliveryId=${deliveryId}` : "";
    const pStype = stype ? `&stype=${stype}` : "";


    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/car/detail?carId=${carId}${carLat}${carLng}${pVw}${st}${et}${pDeliveryId}${pStype}`
    })
}


export function getCar(ex) {
    const carLat = ex && ex.lat > 0 ? `&lat=${ex.lat}` : "";
    const carLng = ex && ex.lng > 0 ? `&lon=${ex.lng}` : "";
    const pPromo = ex.promo ? `&promo=${ex.promo.code}` : "";
    const pLatD = ex.latD && ex.latD !== 0 ? `&latD=${ex.latD}` : "";
    const pLonD = ex.lngD && ex.lngD !== 0 ? `&lonD=${ex.lngD}` : "";

    // with driver
    const pwdDistance = ex.wdDistance >= 0 ? `&wdDistance=${ex.wdDistance}` : "";
    const pwdLocations = ex.wdLocations ? `&wdLocations=${encodeURIComponent(ex.wdLocations)}` : "";
    const pstype = ex.stype ? `&stype=${ex.stype}` : "";
    const pwdOneWay = ex.wdDistance > 0 && ex.wdOneWay !== undefined ? `&wdOneWay=${ex.wdOneWay}` : "";
    const pwdDistanceBackOW = ex.wdDistance > 0 && ex.wdOneWay ? `&wdDistanceBackOW=${ex.wdDistanceBackOW}` : "";

    const pDeliveryId = ex.deliveryId !== undefined ? `&deliveryId=${ex.deliveryId}` : "";
    const pVw = ex && ex.vw ? `&vw=${ex.vw}` : "";
    

    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/car/detail?carId=${ex.carId}&st=${ex.st.valueOf()}&et=${ex.et.valueOf()}${carLat}${carLng}${pLatD}${pLonD}${pPromo}${pwdDistance}${pwdDistanceBackOW}${pwdOneWay}${pwdLocations}${pstype}${pDeliveryId}${pVw}`
    })
}




export function getCarPrice(carId, st, et, latD, lonD, promo, deliveryId, stype, wdDistance, wdDistanceBackOW, wdOneWay, wdLocations) {
    const pPromo = promo ? `&promo=${promo.code}` : "";
    const pLatD = latD !== 0 ? `&latD=${latD}` : "";
    const pLonD = lonD !== 0 ? `&lonD=${lonD}` : "";

    // with driver
    const pwdDistance = wdDistance >= 0 ? `&wdDistance=${wdDistance}` : "";
    const pwdLocations = wdLocations ? `&wdLocations=${encodeURIComponent(wdLocations)}` : "";
    const pstype = stype ? `&stype=${stype}` : "";
    const pwdOneWay = wdDistance > 0 && wdOneWay !== undefined ? `&wdOneWay=${wdOneWay}` : "";
    const pwdDistanceBackOW = wdDistance > 0 && wdOneWay ? `&wdDistanceBackOW=${wdDistanceBackOW}` : "";

    const pDeliveryId = deliveryId !== undefined ? `&deliveryId=${deliveryId}` : "";

    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/car/detail?carId=${carId}&st=${st.valueOf()}&et=${et.valueOf()}${pLatD}${pLonD}${pPromo}${pwdDistance}${pwdDistanceBackOW}${pwdOneWay}${pwdLocations}${pstype}${pDeliveryId}`
    })
}

export function getCarCalendar(carId, startDate, endDate, vw ) {
    const st = startDate ? `&st=${startDate.valueOf()}` : "";
    const et = endDate ? `&et=${endDate.valueOf()}` : "";
    const pVw = vw ? `&vw=${vw}` : "";

    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/car/calendar?carId=${carId}${st}${et}${pVw}`,
    })
}

export function bookCar(carId, instant, dateFrom, dateTo, price, limitEnable, limitKM, limitPrice, useCarLocation, dLat, dLon, dAddr, message, promo, deliveryId, stype, wdDistance, wdDistanceBackOW, wdOneWay, wdLocations, wdPrice, insuranceBy, myAddress, addressId) {

    const ppromo = promo ? `&promo=${promo.code}` : "";
    // self drive
    const pprice = price ? `&price=${price}` : "";
    const plimitEnable = limitEnable ? `&limitEnable=${limitEnable}` : "";
    const plimitKM = limitKM ? `&limitKM=${limitKM}` : "";
    const plimitPrice = limitPrice ? `&limitPrice=${limitPrice}` : "";
    const pinsuranceBy = insuranceBy ? `&insuranceBy=${insuranceBy}` : "";

    // with driver
    const pwdDistance = wdDistance >= 0 ? `&wdDistance=${wdDistance}` : "";
    // Append pickup point to end wdLocations for 2 way
    if (wdLocations && wdOneWay === false && wdDistance > 0) {
        const temp = wdLocations.split(",")
        temp.push(wdLocations.split(",")[0])
        temp.join()
        wdLocations = temp
    }
    const pwdLocations = wdLocations ? `&wdLocations=${encodeURIComponent(wdLocations)}` : "";
    const pstype = stype ? `&stype=${stype}` : "";
    const pwdPrice = wdPrice ? `&wdPrice=${wdPrice}` : "";
    const pwdOneWay = wdDistance > 0 && wdOneWay !== undefined ? `&wdOneWay=${wdOneWay}` : "";
    const pwdDistanceBackOW = wdDistance > 0 && wdOneWay ? `&wdDistanceBackOW=${wdDistanceBackOW}` : "";

    const pDeliveryId = deliveryId !== undefined ? `&deliveryId=${deliveryId}` : "";
    const pAddressId = !useCarLocation && myAddress ? `addressId=${addressId}` : "";

    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/book/car?instant=${instant}&carId=${carId}&dateFrom=${dateFrom}&dateTo=${dateTo}${pprice}${plimitEnable}${plimitKM}${plimitPrice}&useCarLocation=${useCarLocation}&dLat=${dLat}&dLon=${dLon}&dAddr=${dAddr}&message=${message}${ppromo}${pwdDistance}${pwdDistanceBackOW}${pwdOneWay}${pwdLocations}${pstype}${pwdPrice}${pinsuranceBy}${pDeliveryId}${pAddressId}`
    })
}

export function getTrips(filterStatus, fromTripId, pos, ver) {
    const pFromTripId = fromTripId !== 0 ? `&fromTripId=${fromTripId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/traveler/trips?filterStatus=${filterStatus}${pFromTripId}&pos=${pos}&ver=${ver}`
    })
}

export function getOwnerTrips(filterStatus, fromTripId, pos, ver) {
    const pFromTripId = fromTripId !== 0 ? `&fromTripId=${fromTripId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/trips?filterStatus=${filterStatus}${pFromTripId}&pos=${pos}&ver=${ver}`
    })
}

export function getCarTrips(carId, filterStatus, fromTripId, pos, ver) {
    const pFromTripId = fromTripId !== 0 ? `&fromTripId=${fromTripId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/car/trips?carId=${carId}&filterStatus=${filterStatus}${pFromTripId}&pos=${pos}&ver=${ver}`
    })
}

export function getUpcommingTrip(fromTripId, pos, ver) {
    const pFromTripId = fromTripId !== 0 ? `&fromTripId=${fromTripId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/trip/upcoming?&pos=${pos}&ver=$${ver}${pFromTripId}`
    })
}

export function getTripDetail(tripId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/trip/detail?tripId=${tripId}`
    })
}

export function getCancelTripReasons(tripId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/traveler/cancel-reason?tripId=${tripId}`
    })
}

export function cancelTrip(tripId, reasonId, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/traveler/cancel-trip?tripId=${tripId}&reason=${reasonId}&comment=${comment}`
    })
}

export function getCancelTripReasonsOwner(tripId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/cancel-reason?tripId=${tripId}`
    })
}

export function cancelTripOwner(tripId, reasonId, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/cancel-trip?tripId=${tripId}&reason=${reasonId}&comment=${comment}`
    })
}

export function getRejectTripReasonsOwner(tripId) {
    const p = tripId ? `?tripId=${tripId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/reject-reason${p}`
    })
}

export function rejectTripByOwner(tripId, reasonId, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/approve-trip?tripId=${tripId}&reason=${reasonId}&comment=${comment}&reject=true`
    })
}

export function approveTripByOwner(tripId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/approve-trip?tripId=${tripId}&reject=false`
    })
}

export function pickupTrip(tripId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/pickup-trip?tripId=${tripId}`
    })
}

export function returnTrip(tripId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/return-trip?tripId=${tripId}`
    })
}

export function reviewTripByOwner(tripId, rating, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/review?tripId=${tripId}&rating=${rating}&comment=${comment}`
    })
}

export function removePendingReview(tripId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/review/remove-pending?tripId=${tripId}`
    })
}

export function reviewTripByTraveler(tripId, rating, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/traveler/review?tripId=${tripId}&rating=${rating}&comment=${comment}`
    })
}

export function getUserCars(userId, filterStatus, fromCarId, pos, ver, all, stype) {
    const pFromCarId = fromCarId !== 0 ? `&fromCarId=${fromCarId}` : "";
    const pstype = stype ? `&stype=${stype}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/cars?&ownerId=${userId}&filterStatus=${filterStatus}${pFromCarId}&pos=${pos}&ver=${ver}&all=${all || false}${pstype}`
    })
}

export function getOwnerCars(filterStatus, fromCarId, pos, ver, all) {
    const pFromCarId = fromCarId !== 0 ? `&fromCarId=${fromCarId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/cars?filterStatus=${filterStatus}${pFromCarId}&pos=${pos}&ver=${ver}&all=${all || false}`
    })
}

export function getFavoriteCars(fromCarId, pos, ver, stype) {
    const pFromCarId = fromCarId !== 0 ? `&fromCarId=${fromCarId}` : "";
    // wd
    const pstype = stype ? `&stype=${stype}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/fav/cars?pos=${pos}&ver=${ver}${pFromCarId}${pstype}`
    })
}

export function addFavoriteCar(carId, stype) {
    const url = `${baseDomain}/fav/add-car`;

    const params = {
        carId: carId,
        stype: stype || stypes.SD
    }

    return axios({
        method: "POST",
        withCredentials: true,
        url: url,
        params: params
    })
}

export function removeFavoriteCar(carId, stype) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/fav/remove-car?carId=${carId}&stype=${stype || 1}`
    })
}

export function getCarReviews(carId, fromReviewId, pos, ver) {
    const pFromReviewId = fromReviewId !== 0 ? `&fromReviewId=${fromReviewId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/car/reviews?carId=${carId}&pos=${pos}&ver=${ver}${pFromReviewId}`
    })
}

export function getOwnerReviews(userId, fromReviewId, pos, ver) {
    const pFromReviewId = fromReviewId !== 0 ? `&fromReviewId=${fromReviewId}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/traveler/reviews?travelerId=${userId}${pFromReviewId}&pos=${pos}&ver=${ver}`
    })

}

export function getTravelerReviews(userId, fromReviewId, pos, ver) {
    const pFromReviewId = fromReviewId !== 0 ? `&fromReviewId=${fromReviewId}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/owner/reviews?ownerId=${userId}&pos=${pos}&ver=${ver}${pFromReviewId}`
    })
}

export function getCarReportReasons(carId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/report/car-reason?carId=${carId}`
    })
}

export function reportCar(carId, reasonId, comment) {
    const pComment = comment !== "" ? `&comment=${comment}` : "";
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/report/car?carId=${carId}&reason=${reasonId}${pComment}`
    })
}

export function getUserReportReasons(userId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/report/user-reason?userId=${userId}`
    })
}

export function reportUser(userId, reasonId, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/report/user?userId=${userId}&reason=${reasonId}&comment=${comment}`
    })
}

export function getCarSetting(data) {
    var pCarId = "";
    if (data.carId) {
        pCarId = `carId=${data.carId}`;
    }

    var pModelId = "";
    if (data.vehicleModelId) {
        pModelId = `${pCarId !== "" ? "&" : ""}vehicleModelId=${data.vehicleModelId}`
    }

    var pModelYear = "";
    if (data.year) {
        pModelYear = `&year=${data.year}`
    }

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/car/setting?${pCarId}${pModelId}${pModelYear}`
    })
}

export function getFilterConfig() {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/car/filter`
    })
}

export function getVehicleType() {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/vehicle/types`
    })
}

export function getVehicleMake() {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/vehicle/makes`
    })
}

export function getVehicleModel(vehicleType, vehicleMakeId, parentOnly) {
		let vType = "";
		if (vehicleType && vehicleType.length > 0) {
			vType = `&vehicleType=${arrayToString(vehicleType)}`;
		} 
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/vehicle/models?vehicleMakeId=${vehicleMakeId}${vType}&parentOnly=${parentOnly}`
    })
}

export function removeAccountPaper(paperId, photoId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/traveler/remove-paper?paperId=${paperId}&photoIds=${photoId}`
    })
}

export function uploadCarPhoto(carId, carPhotoId, photo) {
    const url = `${baseUploadDomain}/car/upload-photo`;
    const formData = new FormData();
    if (carId !== 0) {
        formData.append('carId', carId);
		}
		formData.append('carPhotoId', carPhotoId);
    formData.append('pdata', photo);
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        },
        withCredentials: true,
        // onUploadProgress: event => {
        //     console.log("Uploaded: " + Math.round(event.loaded / event.total * 100));
        // }
    }
    return axios.post(url, formData, config);
}

export function removeCarPhoto(carId, photoId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/car/remove-photo?carId=${carId}&photoIds=${photoId}`
    })
}

export function uploadCarPaper(carId, paperId, photo) {
    const url = `${baseUploadDomain}/car/upload-paper`;
    const formData = new FormData();
    formData.append('carId', carId)
    formData.append('paperId', paperId)
    formData.append('pdata', photo)
    const config = {
        withCredentials: true,
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return axios.post(url, formData, config);
}

export function removeCarPaper(carId, paperId, photoId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/car/remove-paper?carId=${carId}&paperId=${paperId}&photoIds=${photoId}`
    })
}

export function uploadInsurancePhoto(tripId, imageId, photo) {
    const url = `${baseUploadDomain}/trip/upload-insurance`;
    const formData = new FormData();
    formData.append('tripId', tripId)
    formData.append('imageId', imageId)
    formData.append('pdata', photo)
    const config = {
        withCredentials: true,
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return axios.post(url, formData, config);
}

export function removeInsurancePhoto(tripId, imageId, photoId) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/trip/remove-insurance?tripId=${tripId}&imageId=${imageId}&photoIds=${photoId}`
    })
}
export function activeInsurance(tripId) {
    const url = `${baseDomain}/trip/active-insurance`;
    const params = {
        tripId: tripId
    }

    return axios({
        method: "POST",
        withCredentials: true,
        url: url,
        params: params
    })
}

export function getActiveInsurance(tripId, certNo) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/trip/get-active-insurance?tripId=${tripId}&certNo=${certNo}`
    })
}

export function getPhoneInsurance() {
	return axios({
		method: "GET",
		withCredentials: true, 
		url: `${baseDomain}/trip/get-phone-insurance`
	})
}

export function checkLicensePlate(licensePlate) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/car/check/lp?lp=${licensePlate}`
    })
}

export function registerCar(data) {
    // COMMON PARAMS
    // step 1: car info
    const inviteCode = data.inviteCode ? `&inviteCode=${data.inviteCode}` : "";
    const lp = data.lp ? `lp=${data.lp}` : "";
    const vehicleModelId = data.vehicleModelId ? `&vehicleModelId=${data.vehicleModelId}` : "";
    const seat = data.seat ? `&seat=${data.seat}` : "";
    const year = data.year ? `&year=${data.year}` : "";
  
    const lat = data.lat ? `&lat=${data.lat}` : "";
    const lon = data.lon ? `&lon=${data.lon}` : "";
		const addr = data.addr ? `&addr=${data.addr}` : "";
		const cityId = data.cityId ? `&cityId=${data.cityId}` : "";
		const districtId = data.districtId ? `&districtId=${data.districtId}` : "";
		const wardId = data.wardId ? `&wardId=${data.wardId}` : "";
		const street = data.street !== "" ? `&street=${data.street}` : "";
    const transmission = data.transmission ? `&transmission=${data.transmission}` : "";
    const fuel = data.fuel ? `&fuel=${data.fuel}` : "";
    const fuelConsumption = data.fuelConsumption ? `&fuelConsumption=${data.fuelConsumption}` : "";
    var features = "";
    if (data.features && data.features.length > 0) {
        features = `&features=${arrayToString(data.features)}`;
    }
    const desc = data.desc ? `&desc=${data.desc}` : "";
    // step 3: photo
    var photoTmpIds = "";
    if (data.photoTmpIds && data.photoTmpIds.length > 0) {
        photoTmpIds = `&photoTmpIds=${arrayObjToString(data.photoTmpIds, "id")}`
    }
    // other param
    const mortgages = data.mortgages ? `&mortgages=${data.mortgages}` : "";
    const mortgagesSpecific = data.mortgagesSpecific ? `$mortgagesSpecific=${data.mortgagesSpecific}` : "";

    let commonUrl = `${baseDomain}/owner/add-car?${lp}${vehicleModelId}${seat}${year}${lat}${lon}${cityId}${districtId}${wardId}${street}${addr}${photoTmpIds}${transmission}${fuel}${fuelConsumption}${features}${desc}${mortgages}${mortgagesSpecific}${inviteCode}`
    if (data.selfDrive) {
        // SEPATATE PARAMS
        const deliveryEnable = `&deliveryEnable=${data.deliveryEnable}`;
        const deliveryRadius = data.deliveryRadius ? `&deliveryRadius=${data.deliveryRadius}` : "";
        const deliveryPrice = data.deliveryPrice ? `&deliveryPrice=${data.deliveryPrice}` : "";
        const deliveryRadiusFree = data.deliveryRadiusFree ? `&deliveryRadiusFree=${data.deliveryRadiusFree}` : "";
        const limitEnable = `&limitEnable=${data.limitEnable}`;
        const limitKM = data.limitKM ? `&limitKM=${data.limitKM}` : "";
        const limitPrice = data.limitPrice ? `&limitPrice=${data.limitPrice}` : "";

        const notes = data.notes ? `&notes=${data.notes}` : ""; //policy

        const requiredPapers = data.requiredPapers ? `&requiredPapers=${data.requiredPapers}` : "";
        const requiredPapersSpecific = data.requiredPapersSpecific ? `&requiredPapersSpecific=${data.requiredPapersSpecific}` : "";
        const requiredPapersOther = data.requiredPapersOther ? `&requiredPapersOther=${data.requiredPapersOther}` : "";

        const priceDaily = data.priceDaily ? `&priceDaily=${data.priceDaily}` : "";
        const discountEnable = `&discountEnable=${data.discountEnable}`;
        const discountWeekly = data.discountWeekly ? `&discountWeekly=${data.discountWeekly}` : "";
        const discountMonthly = data.discountMonthly ? `&discountMonthly=${data.discountMonthly}` : "";
        //instant
        const instant = `&instant=${data.instant}`;
        const instantRangeFrom = `&instantRangeFrom=${data.instantRangeFrom}`;
        const instantRangeTo = `&instantRangeTo=${data.instantRangeTo}`;

        const withDriver = "&withDriver=false"
        const selfDrive = "&selfDrive=true"

        return axios({
            method: "POST",
            withCredentials: true,
            url: commonUrl + `${deliveryEnable}${deliveryRadius}${deliveryPrice}${deliveryRadiusFree}${limitEnable}${limitKM}${limitPrice}${notes}${requiredPapersSpecific}${requiredPapers}${requiredPapersOther}${discountEnable}${discountWeekly}${discountMonthly}${priceDaily}${withDriver}${selfDrive}${instant}${instantRangeFrom}${instantRangeTo}`
        })
    }
    // else
    // SEPATATE PARAMS
    const wdDeliveryEnable = `&wdDeliveryEnable=${data.wdDeliveryEnable}`;
    const wdDeliveryRadius = data.wdDeliveryRadius ? `&wdDeliveryRadius=${data.wdDeliveryRadius}` : "";
    const wdDeliveryPrice = data.wdDeliveryPrice ? `&wdDeliveryPrice=${data.wdDeliveryPrice}` : "";
    const wdPolicies = data.wdPolicies ? `&wdPolicies=${data.wdPolicies}` : "";

    const wdDeliveryRadiusFree = data.wdDeliveryRadiusFree ? `&wdDeliveryRadiusFree=${data.wdDeliveryRadiusFree}` : "";
    const wdBasePrice = data.wdBasePrice ? `&wdBasePrice=${data.wdBasePrice}` : "";
    const wdExtraKMFee = data.wdExtraKMFee ? `&wdExtraKMFee=${data.wdExtraKMFee}` : "";
    const wdExtraHourFee = data.wdExtraHourFee ? `&wdExtraHourFee=${data.wdExtraHourFee}` : "";

    // instant
    const wdInstant = `&wdInstant=${data.instant}`;
    const wdInstantRangeFrom = `&wdInstantRangeFrom=${data.instantRangeFrom}`;
    const wdInstantRangeTo = `&wdInstantRangeTo=${data.instantRangeTo}`;

    const withDriver = "&withDriver=true"
    const selfDrive = "&selfDrive=false"

    return axios({
        method: "POST",
        withCredentials: true,
        url: commonUrl + `${wdDeliveryEnable}${wdDeliveryRadius}${wdDeliveryPrice}${wdDeliveryRadiusFree}${wdBasePrice}${wdExtraKMFee}${wdExtraHourFee}${wdPolicies}${mortgages}${mortgagesSpecific}${withDriver}${selfDrive}${wdInstant}${wdInstantRangeFrom}${wdInstantRangeTo}`
    })
}

export function updateCar(carId, data) {
    const instant = data.instant !== undefined ? `&instant=${data.instant}` : "";
    const instantRangeFrom = data.instantRangeFrom !== undefined ? `&instantRangeFrom=${data.instantRangeFrom}` : "";
    const instantRangeTo = data.instantRangeTo !== undefined ? `&instantRangeTo=${data.instantRangeTo}` : "";

    const lat = data.lat !== undefined ? `&lat=${data.lat}` : "";
		const lon = data.lon !== undefined ? `&lon=${data.lon}` : "";
		const cityId = data.cityId ? `&cityId=${data.cityId}` : "";
		const districtId = data.districtId ? `&districtId=${data.districtId}` : "";
		const wardId = data.wardId ? `&wardId=${data.wardId}` : "";
		const street = data.street !== "" ? `&street=${data.street}` : "";
		const addr = data.address !== undefined ? `&addr=${data.address}` : "";


    const deliveryEnable = data.deliveryEnable !== undefined ? `&deliveryEnable=${data.deliveryEnable}` : "";
    const deliveryRadius = data.deliveryRadius !== undefined ? `&deliveryRadius=${data.deliveryRadius}` : "";
    const deliveryRadiusFree = data.deliveryRadiusFree !== undefined ? `&deliveryRadiusFree=${data.deliveryRadiusFree}` : "";
    const deliveryPrice = data.deliveryPrice !== undefined ? `&deliveryPrice=${data.deliveryPrice}` : "";

    const limitEnable = data.limitEnable !== undefined ? `&limitEnable=${data.limitEnable}` : "";
    const limitKM = data.limitKM !== undefined ? `&limitKM=${data.limitKM}` : "";
    const limitPrice = data.limitPrice !== undefined ? `&limitPrice=${data.limitPrice}` : "";

    
    /*----------EXTRA FEE--------*/
    const overTimePriceEnable = data.overTimePriceEnable !== undefined ? `&overTimePriceEnable=${data.overTimePriceEnable}` : "";
    const overTimePrice = data.overTimePrice !== undefined ? `&overTimePrice=${data.overTimePrice}` : "";
    const washingPriceEnable = data.washingPriceEnable !== undefined ? `&washingPriceEnable=${data.washingPriceEnable}` : "";
    const washingPrice = data.washingPrice !== undefined ? `&washingPrice=${data.washingPrice}` : "";
    const deodorisePriceEnable = data.deodorisePriceEnable !== undefined ? `&deodorisePriceEnable=${data.deodorisePriceEnable}` : "";
    const deodorisePrice = data.deodorisePrice !== undefined ? `&deodorisePrice=${data.deodorisePrice}` : "";
    const maxHoursOvertimeEnable = data.maxHoursOvertimeEnable !== undefined ? `&maxHoursOvertimeEnable=${data.maxHoursOvertimeEnable}` : "";
    const maxHoursOvertime = data.maxHoursOvertime !== undefined ? `&maxHoursOvertime=${data.maxHoursOvertime}` : "";
    const batteryChargingPriceEnable = data.batteryChargingPriceEnable !== undefined ? `&batteryChargingPriceEnable=${data.batteryChargingPriceEnable}` : "";
    const batteryChargingPrice = data.batteryChargingPrice !== undefined ? `&batteryChargingPrice=${data.batteryChargingPrice}` : "";


    var photoTmpIds = "";
    if (data.photoTmpIds && data.photoTmpIds.length > 0) {
        photoTmpIds = `&photoIds=${arrayObjToString(data.photoTmpIds, "id")}`
    }

    const fuelConsumption = data.fuelConsumption !== undefined ? `&fuelConsumption=${data.fuelConsumption}` : "";
    var features = "";
    if (data.features && data.features.length > 0) {
        features = `&features=${arrayToString(data.features)}`;
    }

    const desc = data.desc !== undefined ? `&desc=${data.desc}` : "";


    const requiredPapers = data.requiredPapers !== undefined ? `&requiredPapers=${data.requiredPapers}` : "";
    const requiredPapersSpecific = `&requiredPapersSpecific=true`
    const requiredPapersOther = data.requiredPapersOther !== undefined ? `&requiredPapersOther=${data.requiredPapersOther}` : "";

    const mortgages = data.mortgages !== undefined ? `&mortgages=${data.mortgages}` : "";
    const mortgagesSpecific = `&mortgagesSpecific=true`

    const priceDaily = data.priceDaily !== undefined ? `&priceDaily=${data.priceDaily}` : "";
    const discountEnable = data.discountEnable !== undefined ? `&discountEnable=${data.discountEnable}` : "";
    const discountWeekly = data.discountWeekly !== undefined ? `&discountWeekly=${data.discountWeekly}` : "";
    const discountMonthly = data.discountMonthly !== undefined ? `&discountMonthly=${data.discountMonthly}` : "";

    var i;
    var unavails = "";
    if (data.unavailDays) {
        if (data.unavailDays.length === 0) {
            unavails = "&unavails=";
        } else {
            const range = data.unavailDays.map((time) => time.startTime + "-" + time.endTime).toString();
            unavails = `&unavails=${range}`
        }
    }


    var priceSpecific = "";
    if (data.priceSpecifics) {
        if (data.priceSpecifics.length === 0) {
            priceSpecific = "&priceSpecific=";
        } else {
            for (i = 0; i < data.priceSpecifics.length; ++i) {
                const startTs = data.priceSpecifics[i].ts;
                const endTs = startTs + (3600000 * 24) - 1;
                const price = data.priceSpecifics[i].price;

                if (priceSpecific === "") {
                    priceSpecific = `&priceSpecific=${startTs}-${endTs}-${price}`;
                } else {
                    priceSpecific = priceSpecific + `,${startTs}-${endTs}-${price}`;
                }
            }
        }
    }

    var weekday;
    var priceRepeat = "";
    if (data.priceRepeat) {
        if (data.priceRepeat.length === 0) {
            priceRepeat = "&priceRepeat=";
        } else {
            for (i = 0; i < data.priceRepeat.length; ++i) {
                weekday = data.priceRepeat[i].weekday;
                if (weekday === 7) {
                    weekday = 1;
                } else {
                    weekday = weekday + 1;
                }
                const price = data.priceRepeat[i].price;

                if (priceRepeat === "") {
                    priceRepeat = `&priceRepeat=${weekday}-${price}`;
                } else {
                    priceRepeat = priceRepeat + `,${weekday}-${price}`;
                }
            }
        }
    }

    var priceRepeatEndDate = "";
    if (data.priceRepeatEndDate !== undefined) {
        priceRepeatEndDate = `&priceRepeatEndDate=${data.priceRepeatEndDate}`;
    }

    var wdPriceSpecific = "";
    if (data.wdPriceSpecific) {
        if (data.wdPriceSpecific.length === 0) {
            wdPriceSpecific = "&wdPriceSpecific=";
        } else {
            for (i = 0; i < data.wdPriceSpecific.length; ++i) {
                const startTs = data.wdPriceSpecific[i].ts;
                const endTs = startTs + (3600000 * 24) - 1;
                const price = data.wdPriceSpecific[i].price;

                if (wdPriceSpecific === "") {
                    wdPriceSpecific = `&wdPriceSpecific=${startTs}-${endTs}-${price}`;
                } else {
                    wdPriceSpecific = wdPriceSpecific + `,${startTs}-${endTs}-${price}`;
                }
            }
        }
    }

    var weekday;
    var wdPriceRepeat = "";
    if (data.wdPriceRepeat) {
        if (data.wdPriceRepeat.length === 0) {
            wdPriceRepeat = "&wdPriceRepeat=";
        } else {
            for (i = 0; i < data.wdPriceRepeat.length; ++i) {
                weekday = data.wdPriceRepeat[i].weekday;
                if (weekday === 7) {
                    weekday = 1;
                } else {
                    weekday = weekday + 1;
                }
                const price = data.wdPriceRepeat[i].price;

                if (wdPriceRepeat === "") {
                    wdPriceRepeat = `&wdPriceRepeat=${weekday}-${price}`;
                } else {
                    wdPriceRepeat = wdPriceRepeat + `,${weekday}-${price}`;
                }
            }
        }
    }

    var wdPriceRepeatEndDate = "";
    if (data.wdPriceRepeatEndDate !== undefined) {
        wdPriceRepeatEndDate = `&wdPriceRepeatEndDate=${data.wdPriceRepeatEndDate}`;
    }
    // --> price specific, repeat for with driver

    var unavailsRepeat = "";
    if (data.unavailsRepeat) {
        if (data.unavailsRepeat.length === 0) {
            unavailsRepeat = "&unavailsRepeatWeekday=";
        } else {
            for (i = 0; i < data.unavailsRepeat.length; ++i) {
                weekday = data.unavailsRepeat[i].weekday;
                if (weekday === 7) {
                    weekday = 1;
                } else {
                    weekday = weekday + 1;
                }

                if (unavailsRepeat === "") {
                    unavailsRepeat = `&unavailsRepeatWeekday=${weekday}`;
                } else {
                    unavailsRepeat = unavailsRepeat + `,${weekday}`;
                }
            }
        }
    }

    var unavailsRepeatEndDate = "";
    if (data.unavailsRepeatEndDate !== undefined) {
        unavailsRepeatEndDate = `&unavailsRepeatEndDate=${data.unavailsRepeatEndDate}`;
    }

    var unavailsBefore = "";
    if (data.unavailsBefore !== undefined) {
        unavailsBefore = `&unavailsBefore=${data.unavailsBefore}`;
    }

    var unavailsAfter = "";
    if (data.unavailsAfter !== undefined) {
        unavailsAfter = `&unavailsAfter=${data.unavailsAfter}`;
    }
    const notes = data.notes !== undefined ? `&notes=${data.notes}` : "";
    const policiesSpecific = `&policiesSpecific=true`;
    const policies = data.policies !== undefined && data.policiesSpecific !== undefined && data.policiesSpecific === true ? `&policies=${data.policies}` : "";
    const pickupTimes = data.pickupTimes !== undefined ? `&pickupTimes=${data.pickupTimes}` : "";
    const returnTimes = data.returnTimes !== undefined ? `&returnTimes=${data.returnTimes}` : "";
    const minTimes = data.minTimes !== undefined ? `&minTimes=${data.minTimes}` : "";

    // WITH DRIVER PARAMS
    const wdDeliveryEnable = data.wdDeliveryEnable !== undefined ? `&wdDeliveryEnable=${data.wdDeliveryEnable}` : "";
    const wdDeliveryRadius = data.wdDeliveryRadius !== undefined ? `&wdDeliveryRadius=${data.wdDeliveryRadius}` : "";
    const wdDeliveryPrice = data.wdDeliveryPrice !== undefined ? `&wdDeliveryPrice=${data.wdDeliveryPrice}` : "";
    const wdDeliveryRadiusFree = data.wdDeliveryRadiusFree !== undefined ? `&wdDeliveryRadiusFree=${data.wdDeliveryRadiusFree}` : "";
    const wdBasePrice = data.wdBasePrice !== undefined ? `&wdBasePrice=${data.wdBasePrice}` : "";
    const wdExtraKMFee = data.wdExtraKMFee !== undefined ? `&wdExtraKMFee=${data.wdExtraKMFee}` : "";
    const wdExtraHourFee = data.wdExtraHourFee !== undefined ? `&wdExtraHourFee=${data.wdExtraHourFee}` : "";
    const wdPolicies = data.wdPolicies !== undefined ? `&wdPolicies=${data.wdPolicies}` : "";
    const wdPoliciesSpecific = `&wdPoliciesSpecific=true`
    const wdInstant = data.wdInstant !== undefined ? `&wdInstant=${data.wdInstant}` : "";
    const wdInstantRangeFrom = data.wdInstantRangeFrom !== undefined ? `&wdInstantRangeFrom=${data.wdInstantRangeFrom}` : "";
    const wdInstantRangeTo = data.wdInstantRangeTo !== undefined ? `&wdInstantRangeTo=${data.wdInstantRangeTo}` : "";

    const wdMinTimes = data.wdMinTimes !== undefined ? `&wdMinTimes=${data.wdMinTimes}` : "";

    // set withDriver:true for update value of with driver  
    // not set for self drive, 
    const withDriver = data.withDriver !== undefined ? `&withDriver=${data.withDriver}` : "";
    const selfDrive = data.selfDrive !== undefined ? `&selfDrive=${data.selfDrive}` : "";

    return axios({
        method: "POST",
        withCredentials: true,
        /* comment for withdriver */
        url: `${baseDomain}/owner/update-car?carId=${carId}${instant}${instantRangeFrom}${instantRangeTo}${lat}${lon}${cityId}${districtId}${wardId}${street}${addr}${deliveryEnable}${deliveryRadius}${deliveryRadiusFree}${deliveryPrice}${limitEnable}${limitKM}${limitPrice}${photoTmpIds}${fuelConsumption}${features}${desc}${policiesSpecific}${notes}${policies}${requiredPapersSpecific}${requiredPapers}${requiredPapersOther}${mortgages}${mortgagesSpecific}${discountEnable}${discountWeekly}${discountMonthly}${priceDaily}${unavails}${priceSpecific}${priceRepeat}${priceRepeatEndDate}${unavailsRepeat}${unavailsRepeatEndDate}${unavailsBefore}${unavailsAfter}${overTimePriceEnable}${overTimePrice}${washingPriceEnable}${washingPrice}${deodorisePriceEnable}${deodorisePrice}${maxHoursOvertimeEnable}${maxHoursOvertime}${batteryChargingPriceEnable}${batteryChargingPrice}${withDriver}${selfDrive}${wdDeliveryEnable}${wdDeliveryRadius}${wdDeliveryPrice}${wdDeliveryRadiusFree}${wdBasePrice}${wdExtraKMFee}${wdExtraHourFee}${wdPoliciesSpecific}${wdPolicies}${wdPriceSpecific}${wdPriceRepeat}${wdPriceRepeatEndDate}${wdInstant}${wdInstantRangeFrom}${wdInstantRangeTo}${pickupTimes}${returnTimes}${minTimes}${wdMinTimes}`

    })
}

export function removeCar(carId, reasonId, comment) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/remove-car?carId=${carId}&reason=${reasonId}&comment=${comment}`
    })
}

export function invisibleCar(carId, isShow) {
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/owner/invisible-car?carId=${carId}&invisible=${isShow}`
    })
}

export function getCarRequestInfo(reqId) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/request/get-car-request?id=${reqId}`
    })
}

export function responseCarRequest(reqId, accept, msg, rejectReason) {
    const pMsg = msg ? `&msg=${msg}` : "";
    const pRejectReason = rejectReason ? `&rejectReason=${rejectReason}` : "";
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/request/response?id=${reqId}&accept=${accept}${pMsg}${pRejectReason}`
    })
}

export function getCityReviews(city, fromReviewId, pos, ver) {
    const pFromReviewId = fromReviewId !== 0 ? `&fromReviewId=${fromReviewId}` : "";
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/city/reviews?city=${city}&pos=${pos}&ver=${ver}${pFromReviewId}`
    })
}

export function getCarLocationHistory(carId, count, last, dateInSeconds) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/car/loc?carId=${carId}&count=${count}&last=${last}&dateInSeconds=${dateInSeconds}`
    })
}

export function reserveTrip(params) {
    const { tripId, paymentMed, isCancel, code } = params;
    const pCode = code ? `&code=${code}` : "";
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/trip/reserve?tripId=${tripId}&med=${paymentMed}${pCode}&cancel=${isCancel}`
    })
}

export function getMyTrips(filter, fromTripId, pos, ver) {
    const sort = filter.sort > 0 ? `sort=${filter.sort}` : "";
    const userType = filter.userType > 0 ? `&userType=${filter.userType}` : "";
    const status = filter.status > 0 ? `&status=${filter.status}` : "";
    const carId = filter.carId ? `&carId=${filter.carId}` : "";
    const stype = filter.stype ? `&stype=${filter.stype}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/trip/mytrips?${sort}${userType}${status}${carId}&fromTripId=${fromTripId}&pos=${pos}&ver=${ver}${stype}`
    })
}

export function getTripHistories(filter, fromId, pos, ver) {
    const userType = filter.userType > 0 ? `userType=${filter.userType}` : "";
    const status = filter.status > 0 ? `&status=${filter.status}` : "";
    const carId = filter.carId ? `&carId=${filter.carId}` : "";
    const fromTime = filter.fromTime > 0 ? `&fromTime=${filter.fromTime}` : "";
    const toTime = filter.toTime > 0 ? `$toTime=${filter.toTime}` : "";
    const stype = filter.stype ? `&stype=${filter.stype}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/trip/histories?${userType}${status}${carId}${fromTime}${toTime}&fromId=${fromId}&pos=${pos}&ver=${ver}${stype}`
    })
}

export function getTripLocationHistory(tripId, dateInSeconds) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/trip/loc?tripId=${tripId}&dateInSeconds=${dateInSeconds}`
    })
}

export function getCarsLocation(carIds, count, maxTimeInSeconds) {
    const pcount = count ? `&count=${count}` : "";
    const pmaxTimeInSeconds = maxTimeInSeconds ? `&maxTimeInSeconds=${maxTimeInSeconds}` : "";

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/cars-loc?carIds=${carIds}${pcount}${pmaxTimeInSeconds}`
    })
}

export function getCarsLocationSleep(carIds, count) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/sleep-mode/cars-loc?carIds=${carIds}&count=${count}`
    })
}

export function getCarLocationSleepHistory(carId, pos) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/sleep-mode/car/loc?carId=${carId}&pos=${pos}`
    })
}

export function getDeliveryLocations(lat, lon, deliveryPrice, deliveryRadius, deliveryRadiusFree) { 
    return axios({
		method: "GET",
		withCredentials: true, 
		url: `${baseDomain}/car/delivery-locations?lat=${lat}&lon=${lon}&deliveryPrice=${deliveryPrice}&deliveryRadius=${deliveryRadius}&deliveryRadiusFree=${deliveryRadiusFree}`
	})
}

export function getDetailsTripGPS(carId, pos) {
    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseGPSDomain}/list-device-activity?carId=${carId}&pos=${pos}`
    })
}


export function updateGPSDeviceConfig(carId, enableMaxSpeed, maxSpeed, notiOverMaxSpeed, enableCityLimit, cityLimit, notiOutOfCityLimit, enableAreaLimit, areaLimit, notiOutOfAreaLimit) {

    const pEnableMaxSpeed = enableMaxSpeed !== undefined ? `&enableMaxSpeed=${enableMaxSpeed}` : "";
    const pMaxSpeed = maxSpeed !== undefined ? `&maxSpeed=${maxSpeed}` : "";
    const pNotiOverMaxSpeed = notiOverMaxSpeed !== undefined ? `&notiOverMaxSpeed=${notiOverMaxSpeed}` : "";

    const pEnableCityLimit = enableCityLimit !== undefined ? `&enableCityLimit=${enableCityLimit}` : "";
    const pCityLimit = cityLimit !== undefined ? `&cityLimit=${cityLimit}` : "";
    const pNotiOutOfCityLimit = notiOutOfCityLimit !== undefined ? `&notiOutOfCityLimit=${notiOutOfCityLimit}` : "";
    
    const pEnableAreaLimit = enableAreaLimit !== undefined ? `&enableAreaLimit=${enableAreaLimit}` : "";
    const pAreaLimit = areaLimit !== undefined ? `&areaLimit=${areaLimit}` : "";
    const pNotiOutOfAreaLimit = notiOutOfAreaLimit !== undefined ? `&notiOutOfAreaLimit=${notiOutOfAreaLimit}` : "";

    
    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseGPSDomain}/update-gps-device-config?carId=${carId}${pEnableMaxSpeed}${pMaxSpeed}${pNotiOverMaxSpeed}${pEnableCityLimit}${pCityLimit}${pNotiOutOfCityLimit}${pEnableAreaLimit}${pAreaLimit}${pNotiOutOfAreaLimit}`
    })
}
